<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import useConfigStore from './store/configStore';


export default {
  name: 'App',
  mounted() {
    
  }
}
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  position: absolute;
  height: 100%;
  width: 100%;
  color: var(--im-text-color);
  font-family: var(--im-font-family);
}
</style>
